import { getFireworkSound } from '../../Config/Audio';
import { TBoard } from '../../Game/BoardArrangement';
import SoundManager from '../../Sound/SoundManager';
import { PointsDisplay } from '../Shared/PointsDisplay';
import { Firecracker } from './Firecracker';
import { Magnet } from './Magnet';
import { TileBurst } from './TileBurst';
import { TileGoldMatch } from './TileGoldMatch';
import { BoardSprite } from '../Game/Board/BoardSprite';

export const getMatchCoords = (matches: TBoard, size: [number, number]): [number, number] => {
    const matchX =
        matches.reduce((acc, match) => {
            acc += match.position[1] * size[0];
            return acc;
        }, 0) / matches.length;

    const matchY =
        matches.reduce((acc, match) => {
            acc += match.position[2] * size[1];
            return acc;
        }, 0) / matches.length;

    return [matchX + size[0] / 2, matchY];
};

export const tileMatch = (
    matchSprites: BoardSprite[],
    matchCoords: [number, number],
    c: PIXI.Container
) => {
    matchSprites.forEach(match => {
        match.isMatched = true;
        c.addChild(match); // bring to top of display stack
        match.playMatch(matchCoords);
    });
};

export const tileBurst = (size: [number, number], pos: [number, number], c: PIXI.Container) => {
    const b = new TileBurst(size);
    b.x = pos[0];
    b.y = pos[1];
    c.addChild(b);
};

export const goldBurst = (size: [number, number], pos: [number, number], c: PIXI.Container) => {
    const b = new TileGoldMatch();
    b.x = pos[0];
    b.y = pos[1];
    c.addChild(b);
};

export const firework = (
    size: [number, number],
    pos: [number, number],
    c: PIXI.Container,
    playSound?: boolean
) => {
    const b = new Firecracker(size);
    b.x = pos[0];
    b.y = pos[1];
    c.addChild(b);

    if (playSound) {
        SoundManager.playSound(getFireworkSound());
    }
};

export const magnetTile = (size: [number, number], pos: [number, number], c: PIXI.Container) => {
    const b = new Magnet(size);
    b.x = pos[0];
    b.y = pos[1];
    c.addChild(b);
};

export const boardScore = (score: number, pos: [number, number], c: PIXI.Container) => {
    const p = new PointsDisplay(score);
    p.x = pos[0];
    p.y = pos[1];
    c.addChild(p);
    p.showPoints();
};
